import { PricingPlan } from "@/types/dashboard.types";

export const plans: PricingPlan[] = [
  {
    name: "Basic",
    price: 1500,
    credits: 1000,
  },
  {
    name: "Standard",
    price: 3125,
    credits: 2500,
    popular: true,
  },
  {
    name: "Premium",
    price: 5000,
    credits: 5000,
  },
];
